export const styleUploadMap = {
  height: '250px'
}
